import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef } from "react";
import { get, isEmpty } from "lodash";
import getConfig from "next/config";
/**
 * Loads the Marker.io visual feedback widget.
 *
 * - Auto-fills the reporter (email + full name) from the logged-in user.
 * - Attaches org/workspace and app-version metadata to every report.
 *
 * Gated only on the project id env var being present, so it loads on every
 * environment (including onpremise) when configured.
 */
function MarkerIO(_ref) {
  var userInfo = _ref.userInfo;
  var widgetRef = useRef(null);
  var projectId = process.env.NEXT_PUBLIC_MARKERIO_PROJECT_ID;

  // Load the widget once.
  useEffect(function () {
    if (!projectId || typeof window === "undefined") return;
    var isMounted = true;
    import("@marker.io/browser").then(function (_ref2) {
      var markerSDK = _ref2["default"];
      return markerSDK.loadWidget({
        project: projectId
      });
    }).then(function (widget) {
      if (!isMounted) {
        widget.unload();
        return;
      }
      widgetRef.current = widget;
    })["catch"](function (err) {
      // eslint-disable-next-line no-console
      console.error("Failed to load Marker.io widget", err);
    });
    return function () {
      var _widgetRef$current;
      isMounted = false;
      (_widgetRef$current = widgetRef.current) === null || _widgetRef$current === void 0 || _widgetRef$current.unload();
      widgetRef.current = null;
    };
  }, [projectId]);

  // Keep reporter + custom metadata in sync with the logged-in user.
  useEffect(function () {
    var _process;
    var widget = widgetRef.current;
    if (!widget) return;
    var user = get(userInfo, ["details"], {});
    var isLoggedIn = get(userInfo, ["authenticated"], false);
    if (isLoggedIn && !isEmpty(user)) {
      widget.setReporter({
        email: user.email,
        fullName: user.name && user.name !== "undefined" ? user.name : user.email
      });
    } else {
      widget.clearReporter();
    }
    var _ref3 = getConfig() || {},
      publicRuntimeConfig = _ref3.publicRuntimeConfig;
    var commitHash = (_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 || (_process = _process.VERCEL_GIT_COMMIT_SHA) === null || _process === void 0 ? void 0 : _process.substring(0, 7);
    var version = commitHash ? "".concat(publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.version, ".").concat(commitHash) : publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.version;
    var organizations = get(userInfo, ["organizations"], {});
    var organization = Object.values(organizations).map(function (org) {
      return get(org, ["name"], "");
    }).filter(Boolean).join(", ");
    var sources = get(userInfo, ["sources"], []).map(function (source) {
      return get(source, ["name"], "");
    }).filter(Boolean).join(", ");
    widget.setCustomData(_objectSpread(_objectSpread(_objectSpread({}, organization ? {
      organization: organization
    } : {}), sources ? {
      workspaces: sources
    } : {}), version ? {
      appVersion: version
    } : {}));
  }, [userInfo]);
  return null;
}
export default MarkerIO;